import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { format } from '../FONASUAllocationTable/util';
import { toThousands } from '../../flows/shared/utils';
import styles from './FONASUAllocationInput.css';
import { isRPSOCRAccount } from '../../flows/front-office/shared/utils';

const OtherUnit = ({ percentMode, dollarValue, percent }) => (
  <div className="other-unit">
    {Boolean(percentMode) && '$'}
    {format(percentMode ? dollarValue : percent)}
    {Boolean(!percentMode) && '%'}
    <style jsx>{styles}</style>
  </div>
);

const PercentComponent = ({
  percent,
  readOnly,
  onKeyDown,
  handleChange,
  isRPSOCRFlow
}) => {
  return readOnly ? (
    <span>{toThousands(percent)}%</span>
  ) : (
    <>
      <input
        className="number-input percent"
        type="number"
        min="0"
        value={toThousands(percent)}
        step={isRPSOCRFlow ? '0.01' : '1'}
        onKeyDown={onKeyDown}
        onChange={handleChange}
      />
      %<style jsx>{styles}</style>
    </>
  );
};

const DollarComponent = ({
  dollarValue,
  readOnly,
  onKeyDown,
  handleChange
}) => {
  return readOnly ? (
    <span className="dollar">${dollarValue}</span>
  ) : (
    <>
      <input
        className="number-input dollar"
        type="number"
        min="0"
        value={dollarValue}
        step="1"
        onKeyDown={onKeyDown}
        onChange={handleChange}
      />
      $<style jsx>{styles}</style>
    </>
  );
};

const FONASUAllocationInput = ({
  percent = 100,
  dollarValue = 0,
  percentMode = true,
  onChange = () => {},
  readOnly = true,
  accountType
}) => {
  const onOCRKeyDown = event => {
    if (['-'].includes(event.key)) event.preventDefault();
  };

  const onFOKeyDown = event => {
    if (['.', '-'].includes(event.key)) event.preventDefault();
  };

  const handleChange = ({ target: { value } }) => onChange(value);

  const isRPSOCRFlow = isRPSOCRAccount(accountType);

  return (
    <div className={cn('allocation-input', { 'percent-mode': percentMode })}>
      {percentMode ? (
        <PercentComponent
          percent={percent}
          readOnly={readOnly}
          onKeyDown={isRPSOCRFlow ? onOCRKeyDown : onFOKeyDown}
          handleChange={handleChange}
          isRPSOCRFlow={isRPSOCRFlow}
        />
      ) : (
        <DollarComponent
          dollarValue={dollarValue}
          readOnly
          onKeyDown={onFOKeyDown}
          handleChange={handleChange}
        />
      )}

      {readOnly || (
        <OtherUnit
          percentMode={percentMode}
          dollarValue={dollarValue}
          percent={percent}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

FONASUAllocationInput.propTypes = {
  percent: PropTypes.number,
  dollarValue: PropTypes.number,
  percentMode: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool
};

export default FONASUAllocationInput;
